<template>
  <div v-if="item">
    <div v-if="item.dealer_temp">
      <qrcode-vue
        v-if="item.dealer_temp.code"
        :value="item.dealer_temp.code"
      ></qrcode-vue>
      <br />
      <h5>КОД АКТИВАЦИИ: {{ item.dealer_temp.code }}</h5>
      <hr />
    </div>
    <fields-list :item="item" :fields="fields" />
    <div class="save-panel">
      <button class="btn btn-sm btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>Сохранить
      </button>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

import Vue from "vue";
import QrcodeVue from "qrcode.vue";

export default {
  components: {
    QrcodeVue,
  },
  data: () => ({
    cardLink: "dealers",
    cardSetLink: "dealers",
    item: null,
    fields: [
      {
        col: " col-12 col-md-12",
        key: "phone",
        label: "Номер телефона",
        type: "field",
        textType: "text",
        readonly: true,
      },
      //   {
      //   col:' col-12 col-md-3',
      //   key: "bonus",
      //   label: "Бонусы",
      //   type: "field",
      //   textType: "number",
      //   readonly:true
      // },

      {
        col: " col-12 col-md-12",
        key: "code",
        label: "Код дилера (бизнес)",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "last_name",
        label: "Фамилия",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "first_name",
        label: "Имя",
        type: "field",
        textType: "text",
      },

      {
        col: " col-12 col-md-12",
        key: "is_active",
        label: "Активен",
        type: "checkbox",
      },

      {
        col: " col-12 col-md-12",
        key: "users",
        label: "Кураторы",
        type: "selects",
        modal: "user",
        params: { role_code: "tp_admin" },
        selectKey: "phone",
      },
      // {
      //   col:' col-12 col-md-6',
      //   key: "role",
      //   label: "Роль",
      //   type: "select",
      //   modal: "role",
      //   selectKey: "title",
      // },

      //new

      {
        col: " col-12 col-md-6",
        key: "inn",
        label: "ИНН",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "llc_name",
        label: "Название организации",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "trademark",
        label: "Торговая марка",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "accountant_full_name",
        label: "ФИО бухгалтера",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "accountant_phone",
        label: "Телефон бухгалтерии",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "organizationa_address",
        label: "Юр. адрес орг",
        type: "field",
        textType: "text",
      },

      {
        col: " col-12 col-md-6",
        key: "checking_account",
        label: "Расчетный счет",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "mfo",
        label: "МФО банка",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "oked",
        label: "ОКЭД",
        type: "field",
        textType: "text",
      },
    ],
  }),

  props: ["id"],
  async created() {
    // this.pushLang();
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
      if (item && item.id) {
        setTimeout(() => {
          this.item["dealer_temp"] = item["dealer_temp"];
          this.item["is_active"] = item["is_active"];
        }, 50);
      }
    },
  },
};
</script>
<style>
</style>
